import React from "react";
import "./noQuota.scss";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import noAmount from "../../../../../../../images/ocr_image/no-amount.svg";

const NoQuota = ({ isOpen, closeFct }) => (
  <div>
    {isOpen && (
      <div className="modal">
        <div className="modal-content">
          <span className="close" onClick={closeFct}>
            &times;
          </span>
          <p style={{ fontSize: "20px", color: "#121212", fontWeight: "700" }}>
            <FormattedMessage
              id="snaPage.noQuota"
              defaultMessage="免費使用額度已用完"
            />
          </p>
          <img src={noAmount} alt="No amount" />
          <p style={{ fontSize: "16px", color: "#121212", fontWeight: "400" }}>
            <FormattedMessage
              id="snaPage.noQuota.message"
              defaultMessage="今日免費使用額度已達上限，明日AM00:00將重新開放免費使用額度。"
            />
          </p>
        </div>
      </div>
    )}
  </div>
);

export default NoQuota;

NoQuota.defaultProps = {
  isOpen: null,
  closeFct: null,
};

NoQuota.propTypes = {
  isOpen: PropTypes.bool,
  closeFct: PropTypes.func,
};
